module.exports = __webpack_public_path__ + "static/media/bot-bg-tablet-low.af773de5.png";